<template>
  <div class="account">
    <div class="account-menu">
      <el-tabs v-model="menuValue">
        <el-tab-pane
          v-for="item in menuData"
          :key="item.id"
          :label="item.name"
          :name="item.id"></el-tab-pane>
      </el-tabs>
      <div class="account-module">
        <template v-if="menuValue !== 'invoice'">
          <div class="account-module-item">
            <div class="account-module-list" v-for="item in inputBox" :key="item.data">
              <div class="account-module-list__name">{{ item.name }}:</div>
              <div
                class="account-module-list__input"
                :class="{'account-module-list__input--disable': item.isDisable}">
                <input :type="item.type" v-model="userinfo[item.data]" :disabled="item.isDisable">
              </div>
            </div>
          </div>
          <div class="account-module__btn" @click="updataBtnClick()">更新数据</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { AccountNewModule, Account } from './class'
import UserAxios from 'service/user'
export default {
  name: 'account',
  data() {
    return {
      /**菜单 */
      menuData: AccountNewModule.NEWMENU(),
      menuValue: 'basicInfo',
      /**用户信息 */
      userinfo: new Account()
    }
  },
  methods: {
    /**更新按钮点击事件 */
    async updataBtnClick(){
      let obj = {
        'basicInfo': this.userinfo.getChangeUserInfoAxios,
        'password': this.userinfo.getChangePasswordAxios,
        'email': this.userinfo.getChangeEmailAxios,
      }
      let funObj = {
        'basicInfo': UserAxios.changeUserInfo,
        'password': UserAxios.changePassword,
        'email': UserAxios.changeEmail,
      }
      let res = await funObj[this.menuValue](obj[this.menuValue])
      if(res.data.code === 1){
        this.$message.success(res.data.info)
      }else{
        this.$message.error(res.data.info)
      }
    }
  },
  computed:{
    inputBox(){
      let obj = {
        'basicInfo': AccountNewModule.NEWBASICINFO(),
        'password': AccountNewModule.NEWPASSWORD(),
        'email': AccountNewModule.NEWEMAIL(),
      }
      return obj[this.menuValue]
    }
  },
  async created(){
    let obj = {
      'companyName': 'companyName',
      'contactName': 'contactName',
      'id': 'id',
      'email': 'email',
      'phone': 'phone'
    }
    let res = await UserAxios.getUserinfo()
    if(res.data.code === 1){
      this.userinfo.role = res.data.info.authorities[0].authority
      Object.keys(obj).map(key => this.userinfo[key] = res.data.info[obj[key]])
    }
  }
}
</script>

<style lang="scss" scoped>
.account{
  width: 1500px;
  &-menu{
    padding: 0 20px;
    ::v-deep{
      .el-tabs__nav-scroll{
        background-color: none !important;
        height: 45px;
      }
      .el-tabs__item{
        font-size: 12px !important;
      }
      .el-tabs__nav-wrap.is-scrollable{
        background-color: #fff;
      }
      .el-tabs__item.is-active{
        background: none !important;
        height: 40px !important;
        line-height: 40px !important;
        margin: 0 !important;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }
      .el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
        border-bottom-color: #f1f4ff !important;
      }
      .el-tabs__item{
        height: 40px !important;
        line-height: 40x !important;
      }
      .el-tabs__active-bar {
        position: absolute;
        bottom: -4px;
        left: 0;
        height: 2px;
        background-color: #409eff;
        z-index: 1;
        transition: transform .3s cubic-bezier(.645,.045,.355,1);
        list-style: none;
      }
    }
  }
  &-module{
    position: relative;
    height: 600px;
    display: flex;
    justify-content: center;
    align-items: center;
    &-list{
      display: flex;
      align-items: center;
      margin: 15px 0;
      &__name{
        width: 100px;
        text-align: end;
      }
      &__input{
        margin: 0 10px;
        border: 1px solid #DCDFE6;
        padding: 5px 10px;
        input{
          border: none;
          outline: none;
          width: 250px;
        }
        input[disabled]{
          background-color: #f5f7fa;
        }
        &--disable{
          background-color: #f5f7fa;
        }
      }
    }
    &__btn{
      position: absolute;
      bottom: 50px;
      right: 80px;
      padding: 10px 20px;
      border-radius: 5px;
      border: 1px solid #e6e6e6;
      background-color: #238ddf;
      color: white;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
